import React from 'react';
import { Document, Page } from 'react-pdf';
import { ScrollArea } from '@/components/ui/scroll-area';
import { cn } from '@/lib/utils';
import { Loader2 } from 'lucide-react';

export default function PDFSidebar({
    isOpen,
    pdfDocument,
    currentPage,
    onPageClick,
    className
}) {
    if (!isOpen) return null;

    return (
        <div className={cn(
            "w-64 border-r border-[#e5e7eb] bg-gray-50/50 flex flex-col transition-all duration-300 ease-in-out h-full",
            className
        )}>
            <div className="p-4 border-b border-[#e5e7eb] bg-white">
                <h3 className="font-semibold text-sm text-gray-700">Thumbnails</h3>
            </div>

            <ScrollArea className="flex-1">
                <div className="p-4 flex flex-col gap-4">
                    {!pdfDocument ? (
                        <div className="flex justify-center p-4">
                            <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
                        </div>
                    ) : (
                        <div className="flex flex-col gap-4">
                            {Array.from(new Array(pdfDocument.numPages), (_, index) => {
                                const pageNumber = index + 1;
                                const isCurrent = pageNumber === currentPage;

                                return (
                                    <div
                                        key={`thumb-${pageNumber}`}
                                        className={cn(
                                            "cursor-pointer transition-all duration-200 rounded-md overflow-hidden relative group",
                                            isCurrent
                                                ? "ring-2 ring-[hsl(var(--primary))] ring-offset-2 shadow-md"
                                                : "hover:ring-2 hover:ring-gray-300 hover:ring-offset-1 hover:shadow-sm"
                                        )}
                                        onClick={() => onPageClick(pageNumber)}
                                    >
                                        <div className="bg-white p-2 flex justify-center bg-gray-100/50 min-h-[150px]">
                                            {/* High-performance thumbnail rendering: 
                           - renderTextLayer={false} for speed
                           - renderAnnotationLayer={false} for speed
                           - width={200} for small size
                           - pdf={pdfDocument} passed directly to Page
                       */}
                                            <Page
                                                pdf={pdfDocument}
                                                pageNumber={pageNumber}
                                                width={180}
                                                renderTextLayer={false}
                                                renderAnnotationLayer={false}
                                                loading={
                                                    <div className="w-[180px] h-[254px] bg-gray-100 animate-pulse rounded" />
                                                }
                                                className="shadow-sm border border-gray-200"
                                            />
                                        </div>

                                        {/* Page Number Overlay */}
                                        <div className={cn(
                                            "absolute bottom-2 right-2 px-2 py-0.5 rounded text-[10px] font-bold shadow-sm z-10",
                                            isCurrent
                                                ? "bg-[hsl(var(--primary))] text-white"
                                                : "bg-black/50 text-white group-hover:bg-black/70"
                                        )}>
                                            {pageNumber}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </ScrollArea>
        </div>
    );
}
